import { MemoItem } from './Memo';
import { PropertyObject } from './lib/memoTypes';
import { DomWindow } from './DomWindow';
import $ from 'jquery';
import {
    compareObjects,
    dateFromLocalISOString,
    dateToLocalISOString,
    filterObject,
    splitItemRef
} from './util/CoreUtils';
import { EL } from './util/DomUtils';
import { registerClass } from './Plugin';
import {Toolbar} from "./DomMenu";
import {slot} from "./lib/slot";
import {UiContext} from "./util/UiContext";
import {signal} from "./lib";
import {IDocument} from "./IMemoRemote";
import {OnNavigateOptions} from "./ui/Activity";

@registerClass(DomWindow.windowTypes)
export class MemoItemProperties extends DomWindow {
    defaultHideProps : string[] = ["id", "x", "y", "width", "height", "lmt", "mt", "mu", "ct", "cu", "document", "t"];
    showAllProps : boolean = false;
    propEditor: PropertyEditorCtrl;
    toolbar: Toolbar;

    override mobileFullscreen():boolean { return true; }
    static for(item: MemoItem) {
        const id = "itemprops-"+item.parent.documentId+"-"+item.props.id;
        if (id in DomWindow.windows) return DomWindow.windows[id];
        return new MemoItemProperties(item);
    }
    constructor(public item:MemoItem) {
        var pos=item.el.getBoundingClientRect();
        super("itemprops-"+item.parent.documentId+"-"+item.props.id, {x:pos.left,y:pos.top,xx:480,yy:400});
        this.addTitleButton(" 👀 ",()=>this.toggleHideProps());
        this.addTitleButton({title:"Change Item ID", icon:"textfield_rename.png"},async ()=>{
            const newId = await this.item.changeItemIdWithDialog();
            if (newId) {
                this.close();
                this.item.parent.items[newId].editProperties();
            }
        });
        this.addTitleButton("✏️", () => this.item.editText(), true);
        this.toolbar = new Toolbar(true, [], undefined, EL('div', {appendTo: this.contentEl}));

        this.setTitle("Property Editor for "+item.props.id);
        this.propEditor = EL('property-editor-ctrl', {appendTo: this.contentEl}) as PropertyEditorCtrl;

        this.showProperties(item.props);
        this.focus();

        this.propEditor.propertiesModified.connect(changes => {
            this.item.setProperties(changes)
        });

        this.slot(this.item.parent, 'beforeUnloadDocument', this.close.bind(this));
    }
    @slot(() => UiContext.instance.db, $ => $.remoteItemUpdated)
    onRemoteItemUpdate(item: any, docId: string) {
        if (this.item.props.id === item.id && this.item.parent.documentId === docId) {
            this.showProperties(this.item.props);
        }
    }

    updateToolbar() {
        UiContext.instance.sel.buildContextMenu('itemprops', [this.item], null, 'MEMOITEM').then(
             (items) => this.toolbar.setButtons(items));
    }
    isDefaultHidden(key: string) {
        return this.defaultHideProps.indexOf(key) !== -1;
    }
    toggleHideProps() {
        this.showAllProps = !this.showAllProps;
        this.showProperties(this.item.props);
    }
    showProperties(props : PropertyObject) {
        if (!this.showAllProps) props = filterObject(props, ([k, _]) => !this.isDefaultHidden(k));
        this.propEditor.showProperties(props);
        this.updateToolbar();
    }
    override close() {
        super.close();
    }
    focus() {
        super.focus();
        this.$wnd.find("input")[0]?.focus()
    }
}

@registerClass(DomWindow.windowTypes)
export class ObjectProperties extends DomWindow {
    defaultHideProps : string[] = ["id", "x", "y", "width", "height", "lmt", "mt", "mu", "ct", "cu", "document", "t"];
    showAllProps : boolean = false;
    propEditor: PropertyEditorCtrl;
    document: IDocument;
    documentId: string; itemId: string;
    toolbar: Toolbar;

    override mobileFullscreen():boolean { return true; }
    async initUI() {
        super.initUI();
        this.addTitleButton(" 👀 ",()=>this.toggleHideProps());
    }

    async onNavigate(url: URL, options: OnNavigateOptions): Promise<void> {
        await super.onNavigate(url, options);
        this.contentEl.innerHTML = '';

        [this.documentId, this.itemId] = splitItemRef(url.pathname);
        this.document = await UiContext.instance.db.getDocument(this.documentId);
        this.props = this.document.items[this.itemId];

        this.toolbar = new Toolbar(true, [], undefined, EL('div', {appendTo: this.contentEl}));
        //var pos=item.el.getBoundingClientRect();
        //super("", {x:pos.left,y:pos.top,xx:480,yy:400});

        this.setTitle("Properties of "+this.documentId + " / " + this.itemId);
        this.propEditor = EL('property-editor-ctrl', {appendTo: this.contentEl}) as PropertyEditorCtrl;

        this.showProperties(this.props);
        this.focus();

        this.propEditor.propertiesModified.connect(changes => {
            for(const key in changes) {
                if (changes[key] === undefined) delete this.props[key];
                else this.props[key] = changes[key];
            }
            this.document.transact().replace(this.props).commit();
        });

    }
    @slot(() => UiContext.instance.db, $ => $.remoteItemUpdated)
    onRemoteItemUpdate(item: any, docId: string) {
        if (this.itemId === item.id && this.documentId === docId) {
            this.showProperties(item);
        }
    }
    updateToolbar() {
        // TODO UiContext.instance.sel.buildContextMenu('itemprops', [this.item], null, 'MEMOITEM').then(
        // TODO      (items) => this.toolbar.setButtons(items));
    }
    isDefaultHidden(key: string) {
        return this.defaultHideProps.indexOf(key) !== -1;
    }
    toggleHideProps() {
        this.showAllProps = !this.showAllProps;
        this.showProperties(this.props);
    }
    showProperties(props : PropertyObject) {
        if (!this.showAllProps) props = filterObject(props, ([k, _]) => !this.isDefaultHidden(k));
        this.propEditor.showProperties(props);
        this.updateToolbar();
    }
    override close() {
        super.close();
        // TODO  this.item.parent.focus();
    }
    focus() {
        super.focus();
        this.$wnd.find("input")[0]?.focus()
    }
}

export class PropertyEditorCtrl extends HTMLElement {
	//private _shadowRoot: ShadowRoot;
    timestampProps : string[] = ["ct", "mt", "lmt", "ft", "cal", "t"];
    colorProps : string[] = ["backgroundColor", "textColor"];
    private _displayedProps : PropertyObject = {};
    $tab;
    $newrow;
    propertiesModified = signal<(changes: PropertyObject) => void>()
	constructor() {
		super();
		//this._shadowRoot = this.attachShadow({ mode: "open" });
	}
	connectedCallback() {
        this.$tab=$("<table class='propEdit'></table>").appendTo(this);

        this.$newrow=$("<tr class='newrow'><td colspan=2><input placeholder='new property' type=text autocapitalize=\"off\" style=width:200px> <button>add</button></td></tr>").appendTo(this.$tab);
        this.$newrow.find("button").click(() =>{
            var key = this.$newrow.find("input").val() as string;
            this.setProp(key, "");
            $(this).find("[data-prop='"+key+"']").focus();
        });
        this.$newrow.find("input").attr("")

	}
    getFieldType(key: string, value: any) {
        if (this.timestampProps.indexOf(key) !== -1 || key.endsWith('Ts')) {
            return 'datetime-local';
        } else if (typeof value === 'string' && value.indexOf('\n') !== -1) {
            return 'textarea';
        } else if (typeof value === 'object') {
            return 'object';
        } else {
            return 'text';
        }
    }
    _makeInputEl(fieldType: string, key: string): HTMLInputElement | HTMLTextAreaElement {
        const self = this;
        switch(fieldType) {
            case 'datetime-local': {
                const inputEl = EL('input', {type: 'datetime-local'}) as HTMLInputElement;
                inputEl.addEventListener("blur",function() {
                    setTimeout(()=>{
                        self.setProp(key, +dateFromLocalISOString(this.value));
                    }, 0);
                });
                inputEl['_setValue'] = function(val) {
                    if (!isNaN(parseInt(val))) {
                        this.value = dateToLocalISOString(new Date(parseInt(val)));
                    } else {
                        this.value = val;
                    }
                }
                return inputEl;
            }
            case 'textarea': {
                const inputEl = EL('textarea', {width: '100%'}) as HTMLTextAreaElement;
                inputEl.addEventListener("change",function() {
                    setTimeout(()=>{
                        self.setProp(key, this.value);
                    }, 0);
                });
                inputEl['_setValue'] = function(val) {
                    this.value = val;
                }
                return inputEl;
            }
            case 'object': {
                const inputEl = EL('textarea', {width: '100%'}) as HTMLTextAreaElement;
                inputEl.addEventListener("change",function() {
                    setTimeout(()=>{
                        self.setProp(key, JSON.parse(this.value));
                    }, 0);
                });
                inputEl['_setValue'] = function(val) {
                    this.value = JSON.stringify(val, undefined, 2);
                }
                return inputEl;
            }
            case 'text':
            default: {
                const inputEl = EL('input', {type: 'text'}) as HTMLInputElement;
                if (self.colorProps.indexOf(key) !== -1) inputEl.setAttribute('data-colorpicker', '');
                inputEl.addEventListener("change",function() {
                    setTimeout(()=>{
                        self.setProp(key, this.value);
                    }, 0);
                });
                inputEl['_setValue'] = function(val) {
                    this.value = val;
                }
                return inputEl;
            }
        }
    }
    _addRow(key: string, props) {
        const self = this;
        const fieldType = this.getFieldType(key, props[key]);
        const inputEl = this._makeInputEl(fieldType, key);

        inputEl.setAttribute("data-prop", key);
        inputEl.addEventListener("keydown", function(e: KeyboardEvent) {
            if (e.key === 'Backspace' && this.value === '') {
                self.setProp(key, undefined);
            }
            if (e.ctrlKey && e.key == '/') {
                self.toggleComment(key);
                e.preventDefault();
            }
        });
        this.$newrow.before(EL('tr', {}, EL('td', {}, key), EL('td', {}, inputEl)));
        inputEl['_setValue'](props[key]);
    }
    showProperties(props : PropertyObject) {
        var diff = compareObjects(this._displayedProps, props);
        for(const {op, k} of diff) {
            switch(op) {
                case 'a': this._addRow(k, props); break;
                case 'd': this.$tab.find(`[data-prop='${k}']`).closest('tr').remove(); break;
                case 'c': this.$tab.find(`[data-prop='${k}']`)[0]['_setValue'](props[k]); break;
            }
        }
        this._displayedProps = props;
    }
    setProp(key:string, value:string|number) {
        this.propertiesModified.emit({[key]: value});
    }
    toggleComment(key:string) {
        key = key.replace(/^\/\//, '');
        this.propertiesModified.emit({[key]: this._displayedProps['//' + key], ['//' + key]: this._displayedProps[key]});
    }
}
if (window.customElements) {
    window.customElements.define('property-editor-ctrl', PropertyEditorCtrl);
}

